export const PROGRAM_ID = "DcRZHfX9T6fjbD768mG2e21aon224Fu8e8gsihR3R6uR";
// Re-exports so callers (host/, client/, etc.) can keep using `IDL` / `Idl`.
// Anchor 0.30+ stopped emitting a runtime IDL const in target/types/*.ts,
// so we hydrate it from the sibling JSON.
import idlJson from "./last_touch.json" with { type: "json" };
export const IDL = idlJson;
//# sourceMappingURL=last_touch.js.map